import axios from 'axios';
import { getApiUrl } from '../config/runtime';

const getApiBase = () => getApiUrl();

export interface VideoPost {
  id: number;
  user_id: number | null;
  device_id: number;
  channelID: string;
  channelType: 'twitch' | 'youtube' | 'kick';
  channelName?: string;
  profilePicture?: string;
  red: number;
  green: number;
  blue: number;
  hasNewVideo: boolean;
  blink: boolean;
  priority: number;
  muted: boolean;
  watching: boolean;
  locked: boolean;
  lastVideoId?: string;
  created_at: string;
  updated_at: string;
}

const videoPostService = {
  getByDeviceId: async (deviceId: number) => {
    const response = await axios.get<{ videoPosts: VideoPost[] }>(
      `${getApiBase()}/video-posts/device/${deviceId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      }
    );
    return response.data.videoPosts;
  },

  create: async (
    deviceId: number,
    channelID: string,
    channelType: 'twitch' | 'youtube' | 'kick' = 'youtube',
    red: number = 0,
    green: number = 0,
    blue: number = 0,
    blink: boolean = false,
    priority: number = 999
  ) => {
    const response = await axios.post<{ message: string; videoPost: VideoPost }>(
      `${getApiBase()}/video-posts`,
      {
        device_id: deviceId,
        channelID,
        channelType,
        red,
        green,
        blue,
        blink,
        hasNewVideo: false,
        priority,
        muted: false,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      }
    );
    return response.data.videoPost;
  },

  delete: async (videoPostId: number) => {
    const response = await axios.delete<{ message: string }>(
      `${getApiBase()}/video-posts/${videoPostId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      }
    );
    return response.data;
  },

  update: async (videoPostId: number, data: Partial<VideoPost>) => {
    const response = await axios.put<{ message: string; videoPost: VideoPost }>(
      `${getApiBase()}/video-posts/${videoPostId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      }
    );
    return response.data.videoPost;
  },
};

export default videoPostService;
